(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["budget-matched-designs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('budget-matched-designs')) {
    class BudgetMatchedDesigns extends HTMLElement {
      connectedCallback() {
        this.areaInput = document.getElementById('area');
        this.form = document.getElementById('bbForm');
        this.resetButton = document.getElementById('resetBtn');
        this.cards = Array.from(this.querySelectorAll('[data-plan-card]'));
        this.grid = this.querySelector('[data-match-grid]');
        this.heading = this.querySelector('[data-match-title]');
        this.emptyState = this.querySelector('[data-empty-state]');
        this.emptyCopy = this.querySelector('[data-empty-copy]');
        this.ranges = Array.from(new Set(this.cards.map((card) => card.dataset.range)))
          .map((label) => {
            const parsed = this.parseRange(label);
            return parsed ? { label: label, min: parsed.min, max: parsed.max } : null;
          })
          .filter(Boolean)
          .sort((a, b) => a.min - b.min || a.max - b.max);

        this.handleAreaInput = () => this.update();
        this.handleAreaChange = () => this.update();
        this.handleReset = () => setTimeout(() => this.update(), 0);
        this.handleResetClick = () => this.update();

        if (this.areaInput) {
          this.areaInput.addEventListener('input', this.handleAreaInput);
          this.areaInput.addEventListener('change', this.handleAreaChange);
        }

        if (this.form) {
          this.form.addEventListener('reset', this.handleReset);
        }

        if (this.resetButton) {
          this.resetButton.addEventListener('click', this.handleResetClick);
        }

        this.update();
      }

      disconnectedCallback() {
        if (this.areaInput) {
          this.areaInput.removeEventListener('input', this.handleAreaInput);
          this.areaInput.removeEventListener('change', this.handleAreaChange);
        }

        if (this.form) {
          this.form.removeEventListener('reset', this.handleReset);
        }

        if (this.resetButton) {
          this.resetButton.removeEventListener('click', this.handleResetClick);
        }
      }

      parseRange(label) {
        const normalized = String(label).toLowerCase().replace(/,/g, '');
        const values = (normalized.match(/\d+(?:\.\d+)?/g) || []).map(Number);

        if (!values.length) return null;
        if (normalized.includes('under') || normalized.includes('below')) {
          return { min: 0, max: values[0] - 1 };
        }
        if (normalized.includes('over') || normalized.includes('above') || normalized.includes('+')) {
          return { min: values[0], max: Number.POSITIVE_INFINITY };
        }
        if (values.length >= 2) {
          return { min: Math.min(values[0], values[1]), max: Math.max(values[0], values[1]) };
        }

        return { min: values[0], max: values[0] };
      }

      fillTemplate(template, values) {
        return Object.entries(values).reduce((output, entry) => {
          return output.split('__' + entry[0].toUpperCase() + '__').join(String(entry[1]));
        }, template || '');
      }

      update() {
        const fallbackArea = Number(this.dataset.defaultArea) || 1000;
        const inputArea = this.areaInput ? Number(this.areaInput.value) : fallbackArea;
        const area = Number.isFinite(inputArea) && inputArea > 0 ? Math.round(inputArea) : fallbackArea;
        const selectedRange = this.ranges.find((range) => area >= range.min && area <= range.max);
        this.render(area, selectedRange);
      }

      render(area, selectedRange) {
        let visibleCount = 0;

        this.cards.forEach((card) => {
          const isMatch = Boolean(selectedRange) && card.dataset.range === selectedRange.label;
          card.hidden = !isMatch;
          if (isMatch) visibleCount += 1;
        });

        const formattedArea = area.toLocaleString();
        if (this.heading) {
          this.heading.textContent = this.fillTemplate(this.dataset.titleTemplate, {
            count: visibleCount
          });
        }

        if (visibleCount > 0) {
          if (this.grid) this.grid.hidden = false;
          if (this.emptyState) this.emptyState.hidden = true;
        } else {
          if (this.grid) this.grid.hidden = true;

          if (this.emptyCopy) {
            this.emptyCopy.textContent = this.fillTemplate(this.dataset.emptyTemplate, {
              area: formattedArea
            });
          }

          if (this.emptyState) this.emptyState.hidden = false;
        }
      }
    }

    customElements.define('budget-matched-designs', BudgetMatchedDesigns);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
